// src/utils/api.js
// Instância Axios configurada para a API AcreJob

import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
});

// Injeta token automaticamente nas requisições
api.interceptors.request.use(
    (config) => {
        const stored = localStorage.getItem('acrejob-auth');
        if (stored) {
            const { state } = JSON.parse(stored);
            if (state?.token) {
                config.headers.Authorization = `Bearer ${state.token}`;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Trata respostas e erros globais
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const isLoginRoute = error.config?.url?.includes('/auth/login');
            const isAlreadyOnLogin = window.location.pathname === '/login';
            // Só redireciona se não for a rota de login e não estivermos já na login
            if (!isLoginRoute && !isAlreadyOnLogin) {
                localStorage.removeItem('acrejob-auth');
                window.location.href = '/login?sessao=expirada';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
